<template>
  <div v-if="isLayerShow && markers.length > 0 && zoom > zoomIconHide">
    <l-marker v-for="m in markers" :key="m.id" :lat-lng="[m.lat, m.lng]">
      <l-icon :icon-size="[36, 12]" :icon-anchor="[-12, -8]">
        <div class="sensor-contents">
          <div
            class="temperature"
            :style="getTemperatureStyle(m.atmospheric_temperature)"
          >
            {{
              m.atmospheric_temperature !== undefined
                ? m.atmospheric_temperature.toFixed(1)
                : "-"
            }}
            <span class="unit">°C</span>
          </div>
        </div>
      </l-icon>
    </l-marker>
  </div>
</template>
<script>
import { LIcon, LMarker } from "vue2-leaflet";
import { OBSERVATORY } from "../../../enums/Type";
export default {
  name: "ObservatoryHeatLayer",
  components: {
    LIcon,
    LMarker
  },
  data() {
    return {
      markers: []
    };
  },
  computed: {
    observatories() {
      return this.$store.getters.observatories;
    },
    riskSubControl() {
      return this.$store.getters.riskSubControl;
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    isLayerShow() {
      return this.riskSubControl.observatory.includes(OBSERVATORY.HEAT.code);
    },
    zoom() {
      return Math.floor(this.map.getZoom());
    },
    isMobile() {
      return this.$route.path === "/mobile";
    },
    zoomIconHide() {
      return this.isMobile ? 9 : 8;
    }
  },
  watch: {
    observatories() {
      this.fetchMarkers();
    }
  },
  created() {
    //
  },
  beforeDestroy() {
    //
  },
  methods: {
    fetchMarkers() {
      this.$nextTick(() => {
        this.markers = this.$store.getters.observatories.filter(
          obs => obs.type === OBSERVATORY.HEAT.code && obs.lat && obs.lng
        );
      });
    },
    getTemperatureStyle(temperature) {
      let color = "#673ab7";
      if (temperature !== undefined) {
        if (temperature >= 32) {
          color = "#673ab7";
        }
      }
      return { color: color };
    }
  }
};
</script>
<style lang="scss" scoped>
.sensor-contents {
  color: #4d4d4d;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  text-align: center;
  .wbgt {
    width: 38px;
    height: 38px;
    font-size: 14px;
    color: #ffffff;
    background-color: #6ba1f9;
    opacity: 0.8;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 1px 1px 0 #3a3a3a, -1px 1px 0 #3a3a3a, 1px -1px 0 #3a3a3a,
      -1px -1px 0 #3a3a3a;
  }
  .temperature {
    font-size: 16px;
    text-shadow: 1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff,
      -1px -1px 0 #ffffff;
    .unit {
      font-size: 12px;
      margin-left: 1px;
      font-weight: bold;
    }
  }
}
</style>
